module.exports = __webpack_public_path__ + "static/img/backgroung2.94ad41c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/scanner-download/imgs/backgroung2.jpg
// module id = 343
// module chunks = 1